import {ThemeType} from 'types/Theme'

export enum BadgeAttributeVariant {
  BACKGROUND = 'background',
  CONTENT = 'content'
}
export enum BadgeType {
  DEFAULT = 0, // rating with background color and border radius
  COMPACT = 1 // single line rating with no background or border radius
}

/**
 * Get the background and content color for Score rating badge
 *
 * @param theme - the Theme
 * @param value - the Rating Value ranging from 0-10
 * @param attribute - the attribute can be background or content
 * @param badgeType - Whether default badge or compact badge
 *
 * @returns color code for background or content
 */
export const getBadgeAttributeColors = (
  theme: ThemeType,
  value: number,
  attribute: BadgeAttributeVariant,
  badgeType?: BadgeType
) => {
  const themeQualityScale = theme.colors.qualityScale
  switch (badgeType) {
    //TODO: (@find)[post A/B test success]: update the qualityScale to use compact quality scale by adding new tokens for the same
    case BadgeType.COMPACT:
      if (value >= 7) return theme.colors.content.success.c600
      if (value >= 6) return theme.colors.content.warning.c700
      if (value > 0) return theme.colors.content.danger.c600
      return theme.colors.content.neutral.c600

    default:
      if (value >= 9.5) return themeQualityScale['exceptional'][attribute]
      if (value >= 9) return themeQualityScale['excellent'][attribute]
      if (value >= 8.5) return themeQualityScale['veryNice'][attribute]
      if (value >= 8) return themeQualityScale['nice'][attribute]
      if (value >= 7) return themeQualityScale['good'][attribute]
      if (value >= 6) return themeQualityScale['average'][attribute]
      if (value > 0) return themeQualityScale['poor'][attribute]
      return themeQualityScale['default'][attribute]
  }
}
